// extracted by mini-css-extract-plugin
module.exports = {"bodySections":"BodySections-module--body-sections--1NyTb"};